import NamedContact from "../../named-contact";
import CredentialedResource from "../credentialed-resource";
import isVolunteerPreferences from "../resource-schedule-guard";
import VolunteerPreferences from "./volunteer-preferences";
import VolunteerSchedule from "./volunteer-schedule";
import { VolunteerType } from "./volunteer-type";

export default class Volunteer
  extends CredentialedResource
  implements NamedContact
{
  private _languages: number[] = [];
  private _volunteerType: VolunteerType;
  private _trainingCompletionDate: Date;
  private _title: string;
  private _preferences: VolunteerPreferences;

  constructor(
    languages: number[] = [],
    volunteerType: VolunteerType = null,
    trainingCompletionDate: Date = null,
    title: string = "",
    preferences: VolunteerPreferences = null
  ) {
    super();
    this._languages = languages;
    this._volunteerType = volunteerType;
    this._trainingCompletionDate = trainingCompletionDate;
    this._title = title;
    if (preferences == null) {
      preferences = new VolunteerPreferences(new VolunteerSchedule());
    }
    this.preferences = new VolunteerPreferences(
      preferences.schedule,
      preferences.skillsAndInterests
    );
  }

  get preferences(): VolunteerPreferences {
    return this._preferences;
  }

  set preferences(value: VolunteerPreferences) {
    this._preferences = value;

    // memoizing the values for future lookup speed
    if (isVolunteerPreferences(value)) {
      for (let i = 0; i < value.skillsAndInterests.length; i++) {
        const x = value.skillsAndInterests[i];
        this._preferences.addCachedSkill(x);
      }
    }
  }

  public convertVolunteerTypeToArray(): number[] {
    let n = [];

    if (!this.volunteerType) return n;

    if (
      (this.volunteerType & VolunteerType.OFFICE_ADMIN) ===
      VolunteerType.OFFICE_ADMIN
    )
      n.push(VolunteerType.OFFICE_ADMIN);
    if (
      (this.volunteerType &
        VolunteerType.COMPANION_SUPPORT_TO_PATIENT_FAMILY) ===
      VolunteerType.COMPANION_SUPPORT_TO_PATIENT_FAMILY
    )
      n.push(VolunteerType.COMPANION_SUPPORT_TO_PATIENT_FAMILY);
    if (
      (this.volunteerType &
        VolunteerType.PROFESSIONAL_SERVICE_TO_PATIENT_FAMILY) ===
      VolunteerType.PROFESSIONAL_SERVICE_TO_PATIENT_FAMILY
    )
      n.push(VolunteerType.PROFESSIONAL_SERVICE_TO_PATIENT_FAMILY);
    if (
      (this.volunteerType & VolunteerType.SPECIAL_PROJECTS) ===
      VolunteerType.SPECIAL_PROJECTS
    )
      n.push(VolunteerType.SPECIAL_PROJECTS);

    return n;
  }

  get languages(): number[] {
    return this._languages;
  }

  set languages(value: number[]) {
    this._languages = value;
  }

  get volunteerType(): VolunteerType {
    return this._volunteerType;
  }

  set volunteerType(value: VolunteerType) {
    this._volunteerType = value;
  }

  get trainingCompletionDate(): Date {
    return this._trainingCompletionDate;
  }

  set trainingCompletionDate(value: Date) {
    this._trainingCompletionDate = value;
  }

  get title(): string {
    return this._title;
  }

  set title(value: string) {
    this._title = value;
  }
}



// WEBPACK FOOTER //
// ./src/models/resource-management/volunteers/volunteer.ts